/**
 * LES APPELS DU POSTE CLIENT ET DES ENCAISSEMENTS — lot 158, 03/11/2026.
 * Routes de `apps/api/src/recouvrement_pl.ts`. Même contrat que `api.ts`.
 */

import { appeler, echec, type Resultat } from './api.js';
import type { Encaissements, Poste } from './recouvrementPl.js';

export async function lirePoste(jeton: string): Promise<Resultat<Poste>> {
  const e = await appeler('/recouvrement-pl/poste', jeton);
  if (e.etat !== 'succes') return echec(e);
  return { etat: 'ok', valeur: e.corps as Poste };
}

export async function lireEncaissements(
  jeton: string,
  du: string,
  au: string,
): Promise<Resultat<Encaissements>> {
  const q = new URLSearchParams({ du, au });
  const e = await appeler(`/recouvrement-pl/encaissements?${q.toString()}`, jeton);
  if (e.etat !== 'succes') return echec(e);
  return { etat: 'ok', valeur: e.corps as Encaissements };
}
